import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { OperationFilter } from "../../shared/operation-filter";
import { formatFilterDate } from "../../shared/operation-filter.utils";

@Injectable({
  providedIn: 'root'
})
export class OperationListService {
  filters: BehaviorSubject<OperationFilter> = new BehaviorSubject({} as OperationFilter);

  isSetDate: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  personalizedFilterActive = false;

  patchFilters(patch: Partial<OperationFilter>): void {
    this.personalizedFilterActive = false;
    const merged = this.normalize({ ...this.filters.value, ...patch });
    if (!this.shallowCompare(this.filters.value, merged)) {
      this.filters.next(merged);
    }
  }

  setFilters(filters: OperationFilter): void {
    this.personalizedFilterActive = true;
    this.filters.next(this.normalize(filters));
  }

  private normalize(f: OperationFilter): OperationFilter {
    const trim = (s?: string) => (typeof s === 'string' ? s.trim() : s);

    return {
      operationCode: trim(f.operationCode) || undefined,
      holderCode: trim(f.holderCode) || undefined,
      purchaserCode: trim(f.purchaserCode) || undefined,
      carbonCreditCode: trim(f.carbonCreditCode) || undefined,
      typeCode: trim(f.typeCode as string | undefined) || undefined,
      initialDate: formatFilterDate(f.initialDate),
      finalDate: formatFilterDate(f.finalDate),
    };
  }

  shallowCompare(a: any, b: any): boolean {
    if (a === b) return true;
    if (!a || !b) return false;
    const ak = Object.keys(a);
    const bk = Object.keys(b);
    if (ak.length !== bk.length) return false;
    for (const k of ak) {
      if (a[k] !== b[k]) return false;
    }
    return true;
  }
}
